



















import { Component, Mixins } from "vue-property-decorator";
import { CircleSelectItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { CircleSelectObjectStyleReader } from "../styleReaders";
import {
  StyledCheckEditableObjectMixin,
  LineDrawableMixin,
  CircleDrawableMixin
} from "./mixins";

@Component({
})
export default class CircleSelectObject extends Mixins(
  StyledCheckEditableObjectMixin,
  LineDrawableMixin,
  CircleDrawableMixin
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new CircleSelectObjectStyleReader(configuration.style.document.editor.objects.circleSelect);
  }

  editingSource: CircleSelectItem;
}
